<template>
  <div class="medicalNews">
    <el-form ref="form" :rules="rules" label-width="100px">
      <div class="module-title">
        <span>基础信息</span>
      </div>
      <el-row>
        <el-col :span="23">
          <el-form-item :span="10" label="病例名称:" prop="caseName">
            <el-col :span="24">
              <el-input maxlength="50" v-model="detail.caseName" placeholder="请输入病例名称"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item :span="10" label="性别:" prop="caseSex">
            <el-col :span="20">
              <el-select style="width: 100%;" v-model="detail.caseSex" placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="age">
          <el-form-item :span="10" label="年龄:" prop="caseAge">
            <el-col :span="20">
              <el-input v-model="detail.caseAge"  placeholder="请输入年龄" class="inputAge"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="garal">
            <el-col :span="24">
              <el-select style="width: 100%;" v-model="detail.ageUnit" placeholder="请选择" class="inputAgeUnit">
               <el-option v-for="item in options2"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="23">
          <el-form-item :span="10" label="备注:">
            <el-col :span="24">
              <el-input placeholder="请输入备注" maxlength="340" v-model="detail.remark" type="textarea"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="module-title">
        <span>就诊信息</span>
      </div>
      <el-row class="row">
        <el-col :span="23">
          <el-form-item :span="10" label="病史:">
            <el-col :span="24">
              <el-input placeholder="请输入病史" maxlength="340" v-model="detail.history" type="textarea"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="23">
          <el-form-item :span="10" label="病理结果:">
            <el-col :span="24">
              <el-input placeholder="请输入病理结果" maxlength="1300" v-model="detail.caseResult" type="textarea"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="23">
          <el-form-item :span="10" label="检查所见:">
            <el-col :span="24">
              <el-input placeholder="请输入检查所见" maxlength="1300" v-model="detail.evidence" type="textarea"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row">
        <el-col :span="23">
          <el-form-item :span="10" label="诊断结果:">
            <el-col :span="24">
              <el-input placeholder="请输入诊断结果" v-model="detail.dianogeResult" type="textarea"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: "medicalNews",
    props: {
      info: {
        type: Object,
        default: function () {
          return {
            reportType: '',
            reportInfo: {},
          }
        }
      },
      /*CaseInfo: {
         type: Object,
         default: function () {
           return {}
         }
      }*/
    },
    watch: {
      'detail.ageUnit': {
        handler:function(val,oldVal){
          // alert(val)
          this.$emit('detailUpdate', this.detail)
        },
        deep:true,
      }
    },
    data() {
      let caseNameTest = (rule, value, callback) => {
        if (this.detail.caseName === '') {
          return callback(new Error('病例名不能为空'));
        } else {
          callback()
        }
      }
      let caseAgeTest = (rule, value, callback) => {
        if (this.detail.caseAge === '') {
          return callback();
        } else {
          let reg = /^[0-9]*$/
          if (reg.test(this.detail.caseAge)) {
            if (parseInt(this.detail.caseAge) > 999) {
              return callback(new Error('请输出合理的数字'))
            }
            callback()
          } else {
            return callback(new Error('只能输入数字'))
          }
        }
      }
      let caseSexTest = (rule, value, callback) => {
        if (this.detail.caseSex === '') {
          return callback(new Error('请选择性别'));
        } else {
          callback()
        }
      }
      return {
        rules: {
          caseName: [
            { required: true, validator: caseNameTest, trigger: 'blur' },
          ],
          caseAge: [
            { required: false, validator: caseAgeTest, trigger: 'blur' },
          ],
          caseSex: [
            { required: true, validator: caseSexTest, trigger: 'change' },
          ]
        },
        detail: {
          caseName: '',
          caseSex: '',
          caseAge: '',
          ageUnit: '',
          remark: '',
          history: '',
          caseResult: '',
          evidence: '',
          dianogeResult: '',
        },
        options: [
          {value: '1',label: '男'},
          {value: '0',label: '女'}
        ],
        sex: '',
        options2: [
          {value: '4',label: '岁'},
          {value: '3',label: '月'},
          // {value: '2',label: '周'},
          {value: '1',label: '天'},
          {value: '5',label: '小时'}
        ]
      }
    },
    methods: {
    },
    updated() {
      this.$emit('detailUpdate', this.detail)
    },
    /*watch:{
      CaseInfo(){
        this.detail = this.CaseInfo;
      }
    },*/
    created() {
      //console.log(this.info)
      //console.log('=============')
      this.detail = this.info
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .module-title
    height: 50px
    line-height: 50px
    border-bottom: none

  .module-title > span
    border-left: 2px solid #333
    text-indent: 10px
    padding-left: 10px
    margin-left: 10px
    color: #333
</style>



// WEBPACK FOOTER //
// medicalNews.vue?1809b25e